import axios from 'axios';

const state = () => ({
  photos: [],
  loading: false,
});

const getters = {
  isPhotosEmpty: state => {
    return state.photos.length === 0;
  },
};

const mutations = {
  setPhotos(state, photos) {
    state.photos = photos;
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
};

const actions = {
  async fetchPhotos({ commit, dispatch, rootState }) {
    commit('setLoading', true);
    const accessToken = rootState.user.token;
    try {
      const { data: photos } = await axios.get(process.env.VUE_APP_API_URL + '/photo/all', {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      commit('setPhotos', photos);
    } catch (e) {
      dispatch('toast/error', 'Failed to fetch photos.', { root: true });
    } finally {
      commit('setLoading', false);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
